"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNextApiConfig = exports.NextApiSwrProvider = exports.useNextApiFetcher = exports.useNextApiFetch = exports.NextApiConfigContext = void 0;
var browser_fetcher_1 = require("@newfront-insurance/browser-fetcher");
var react_1 = __importStar(require("react"));
var util_1 = require("./util");
exports.NextApiConfigContext = (0, react_1.createContext)(null);
/**
 * Creates a fetcher instance with the Next API set as the base url.
 */
function useNextApiFetch() {
    var fetcher = useNextApiConfig().fetcher;
    function fetch(options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, data, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetcher.request(options)];
                    case 1:
                        _a = _b.sent(), data = _a.data, error = _a.error;
                        if (error) {
                            throw error;
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    }
    return fetch;
}
exports.useNextApiFetch = useNextApiFetch;
/**
 * Creates a fetcher instance with the Next API set as the base url.
 */
function useNextApiFetcher() {
    var fetcher = useNextApiConfig().fetcher;
    return fetcher;
}
exports.useNextApiFetcher = useNextApiFetcher;
/**
 * Configure the Next API hooks.
 */
function NextApiSwrProvider(props) {
    var children = props.children, mockFetcher = props.mockFetcher, authToken = props.authToken;
    var baseUrl = (0, util_1.useNextApiBaseUrl)();
    var fetcher = (0, react_1.useMemo)(function () {
        if (mockFetcher) {
            return mockFetcher;
        }
        return new browser_fetcher_1.Fetcher({
            baseUrl: baseUrl,
            token: authToken,
        });
    }, [baseUrl, mockFetcher, authToken]);
    return react_1.default.createElement(exports.NextApiConfigContext.Provider, { value: { fetcher: fetcher } }, children);
}
exports.NextApiSwrProvider = NextApiSwrProvider;
/**
 * Get the current Next API config object
 */
function useNextApiConfig() {
    var legacyConfig = (0, react_1.useContext)(exports.NextApiConfigContext);
    if (legacyConfig) {
        return legacyConfig;
    }
    throw new Error('Missing NextApiSwrProvider');
}
exports.useNextApiConfig = useNextApiConfig;
